import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import Box from "@mui/material/Box";

import { takeSurvey } from "../../actions/surveyActions";
import Survey from "./Survey";
import { Paper, Typography } from "@mui/material";
import LogoName from "../Logo";

const TakeSurvey = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const survey_id = searchParams.get('survey_id')

    useEffect(() => {
        dispatch(takeSurvey(survey_id))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <Box
            sx={{
                bgcolor: 'primary.main',
                width: '100%',
                minHeight: '100vh',
                position: 'relative', // Allow absolute positioning of the Typography
            }}
        >
            {/* Top-left Typography */}
            <Box
                sx={{
                    position: 'absolute', // Position the Typography absolutely
                    top: 16, // Adjust top margin
                    left: 16, // Adjust left margin
                    zIndex: 10, // Ensure it appears above other elements
                    color: 'white', // Ensure readability against the background
                }}
            >
                <LogoName />
            </Box>

            {/* Centralized Paper */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh', // Full viewport height for centralization
                }}
            >
                <Paper
                    sx={{
                        maxWidth: 1100,
                        width: '90%', // Adjust width to fit within the screen responsively
                        height: '98vh', // Set the height to 98% of the viewport height
                        overflow: 'auto', // Ensure content is scrollable if necessary
                        p: 3, // Add some padding inside the Paper
                    }}
                >
                    <Typography variant="h6" sx={{ mb: 5 }}>Survey</Typography>
                    <Survey surveyLink={survey_id} />
                </Paper>
            </Box>
        </Box>
    )
}

export default TakeSurvey